import { ENG_INIT } from "../../constants/engineering";

export const defaultState = {};

const nodes = (state = {}, action) => {
  switch (action.type) {
    case ENG_INIT:
      return action.data.engineering.nodeIds || {};
    default:
      return state;
  }
};

export default nodes;
